import  { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

interface VoidedTransactionModalProps {
  readonly message: string;
}

function VoidedTransactionModal({ message }: VoidedTransactionModalProps) {
  const [open, setOpen] = useState<boolean>(true);
  const { t } = useTranslation('common');
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth
        sx={{ p: 0 }}>
        <DialogTitle sx={{ m: 4, p: 4 }}>
          {t('transactions.transactionVoid')}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.custom.gray[800],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
          <Typography variant="textMD"
            sx={{ my: 4, mb: 10, mx: 6 }}>
            {message}
          </Typography>
        </DialogContent>
      </Dialog>

    </div>
  );
}

export default VoidedTransactionModal;
